// ADDED
import axios from "../../api/apiClient";
import { domain, token } from "../../components/Security";

const headers = {
  Authorization: `Bearer ${token}`,
  "Content-Type": "application/json",
};

const offsetService = {
  // Fetch history for the history modal
  getByEmployee: async (employeeId, days = 30) => {
    return await axios.get(`${domain}/api/OffsetRequest/employee/${employeeId}/days-range/${days}`, { headers });
  },

  // Reference selection data
  getOvertimeReferences: async (employeeId) => {
    return await axios.get(`${domain}/api/OffsetOvertime/employee/${employeeId}`, { headers });
  },

  getLeaveReferences: async (employeeId) => {
    return await axios.get(`${domain}/api/OffsetLeave/employee/${employeeId}`, { headers });
  },

  // Create steps
  create: async (payload) => {
    return await axios.post(`${domain}/api/OffsetRequest`, payload, { headers });
  },

  createApproval: async (payload) => {
    return await axios.post(`${domain}/api/Approval/0`, payload, { headers });
  },

  // Approver contacts for SMS
  getApproverHierarchy: async (employeeId) => {
    return await axios.get(`${domain}/api/ApproverHierarchy/${employeeId}`, { headers });
  },

  getEmployeeInfo: async (employeeId) => {
    return await axios.get(`${domain}/api/Employee/${employeeId}`, { headers });
  },

  sendSmsNotification: async (smsData) => {
    // Keeping legacy IP as requested
    return await axios.post("http://161.49.93.114:8081/api/Sms/send-sms", smsData);
  }
};

export default offsetService;